import React from "react";
import { Alert } from "@mui/material";

const ErrorAlertInvite = ({ errorMsg, handleClose }) => {
  return (
    <Alert
      severity="error"
      onClose={handleClose}
      style={{ textAlign: "start", overflowY: "scroll", width: "100%" }}
    >
      <p style={{ fontWeight: "600" }}>{errorMsg?.title}</p>
      <p>{errorMsg?.details}</p>
      <pre
        style={{
          fontFamily: "inherit",
          textAlign: "start",
          overflowX: "auto",
          whiteSpace: "pre-wrap",
        }}
      >
        {errorMsg?.context}
      </pre>
    </Alert>
  );
};

export default ErrorAlertInvite;
